import { ACTOR_TAGS } from "@/presentation/helpers/actorTags.js";

/**
 * Base Line Actor Factory.
 * Mimics the "Abstract Class" approach used in ActionCard.js.
 * Provides common components and enforces the implementation of slide(), jumpTo() and hit().
 */
export function createBaseLineActor(k, options) {
    const {
        sprite,
        spriteOptions = {},
        position,
        index,
        isDuck,
        z = 8,
        tags = [],
        extraComponents = []
    } = options;

    const actor = k.add([
        k.sprite(sprite, spriteOptions),
        k.pos(position.x, position.y),
        k.anchor("center"),
        k.area(),
        k.z(z),
        ACTOR_TAGS.LINE_ACTOR,
        ...tags,
        ...extraComponents,
        {
            slotIndex: index,
            isDuck: isDuck,
            isAnimating: false,
            protected: false,
        }
    ]);

    // Mandatory Methods (The "Interface")
    // Throws errors if called but not implemented by the specific prefab factory.
    actor.slide = async (targetX, duration) => {
        throw new Error(`[LineActor] slide() must be implemented for ${sprite}`);
    };

    actor.jumpTo = async (targetPos, duration) => {
        throw new Error(`[LineActor] jumpTo() must be implemented for ${sprite}`);
    };

    actor.hit = async () => {
        throw new Error(`[LineActor] hit() must be implemented for ${sprite}`);
    };

    actor.poke = async () => {
        throw new Error(`[LineActor] poke() must be implemented for ${sprite}`);
    };

    actor.jump = async () => {
        throw new Error(`[LineActor] jump() must be implemented for ${sprite}`);
    };

    return actor;
}
